<div class="c-tournamentRanking">
  <div
    class="e-tournamentRanking__background"
    theming
    themingGroup="tournament"
    themingAsset="background"
    [themingOverride]="event?.assets">
    <slotcom-navigation-button
      type="info"
      (click)="openInfo()">
    </slotcom-navigation-button>

    <slotcom-navigation-button
      type="close"
      (click)="closeModal()">
    </slotcom-navigation-button>

    <div
      class="e-tournamentRanking__logo"
      theming
      themingGroup="tournament"
      themingAsset="logo"
      [themingOverride]="event?.assets"></div>

    @if (gameId) {
      <div
        class="e-tournamentRanking__featured-box"
        theming
        themingGroup="tournament"
        themingAsset="featured-box"
        [themingOverride]="event?.assets">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <div
            class="gameIcon"
            [ngStyle]="gameIcon"
            avoidMulticlick
            (safeClick)="handleRankingButtonClick()"></div>

          <div class="featured-box-text">
            {{ 'home.live-ops.tournaments.modal-ranking.featured-box' | translate }}
          </div>
        </div>
      </div>
    }

    <div
      #mainContainer
      class="e-tournamentRanking__container">
      @if (!loadingRanking()) {
        @for (player of rankingList(); track player.userId; let i = $index) {
          @if (player.userId === user.id) {
            <div class="hidden-user-container">
              <div
                #hiddenUser
                class="hidden-user"></div>
            </div>

            <slotcom-tournament-ranking-list
              #mainUserSticky
              class="sticky-user"
              [event]="event"
              [player]="player"
              [rankingPosition]="i + 1"
              [rankingPrize]="rankingPrizeList()[i]"></slotcom-tournament-ranking-list>
          } @else {
            <slotcom-tournament-ranking-list
              [event]="event"
              [player]="player"
              [rankingPosition]="i + 1"
              [rankingPrize]="rankingPrizeList()[i]"
              (click)="openUserProfile(player.userId)"></slotcom-tournament-ranking-list>
          }
        }
      } @else {
        <slotcom-loading> </slotcom-loading>
      }
    </div>

    <div class="e-timer">
      <span class="text">{{ 'home.live-ops.global.time-left' | translate }}</span>

      <slotcom-animated-timer
        [showInDays]="true"
        [endDate]="event?.endDate"
        (expired)="closeModal()"></slotcom-animated-timer>
    </div>

    <slotcom-button
      class="c-button--pink"
      audioType="functionality"
      (safeClick)="handleRankingButtonClick()">
      {{ buttonText | translate | uppercase }}
    </slotcom-button>
  </div>
</div>
